import { Scenario, ScenarioType, Steps } from '../state/interfaces'
import {
  emailAddressEmailCollector,
  currentProviderMobileEmailCollector,
  currentProviderInternetEmailCollector,
  thanksEmailCollector,
  provincesEmailCollector,
} from './email-collector-steps'

export const emailCollectorScenarioA: Scenario = {
  id: 'email-collector-a',
  initialStep: Steps.PROVINCE,
  type: ScenarioType.EMAIL_COLLECTOR,
  version: '1',
  milestones: [
    provincesEmailCollector.id,
    emailAddressEmailCollector.id,
    currentProviderMobileEmailCollector.id,
    currentProviderInternetEmailCollector.id,
    thanksEmailCollector.id,
  ],
  steps: [
    provincesEmailCollector,
    emailAddressEmailCollector,
    currentProviderMobileEmailCollector,
    currentProviderInternetEmailCollector,
    thanksEmailCollector,
  ],
  weight: 1,
}
